import React, { Component } from 'react';
import Header from 'components/Admin/Header';
import Sidebar from 'components/Admin/Sidebar';
import Footer from 'components/Admin/Footer';
import AdminRoutes from 'Routes/AdminRoutes';
import { getAuthToken, isTokenExpired, clearAllAuthStorage, getOrRefreshAccessToken } from 'utils/jwtInterceptor';

class ConfigAdmin extends Component {
    componentDidMount() {
        this.getAuth();
        this.checkLoginSession();
    }

    getAuth = async () => {
        var authId = localStorage.getItem('adm') || localStorage.getItem('icmb');
        var un = localStorage.getItem('un') || localStorage.getItem('nim');

        if (!authId || !un) {
            clearAllAuthStorage();
            window.location.replace('/');
        }
    };

    checkLoginSession = () => {
        const jwt = getAuthToken();
        const refreshToken = localStorage.getItem('refresh_token') || sessionStorage.getItem('refresh_token');
        if (jwt && isTokenExpired(jwt) && !refreshToken) {
            clearAllAuthStorage();
            window.location.replace('/');
            return;
        }

        if (refreshToken && (!jwt || isTokenExpired(jwt, 60))) {
            getOrRefreshAccessToken('front-office').catch((e) => {
                console.warn('[ConfigAdmin Auto-Refresh Failed]:', e);
            });
        }
    };

    render() {
        window.scroll(0, 0)
        return (
            <div className='wrapper'>
                <Header />
                <Sidebar />
                <div className='main-panel'>
                    <AdminRoutes />
                    <Footer />
                </div>
            </div>
        );
    }
}

export default ConfigAdmin;
